import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import ro from 'vuetify/es5/locale/ro'
import Scroll from 'vuetify/es5/directives/scroll'

Vue.use(Vuetify, {
  theme: {
    primary: '#00b693',
    accent: '#297dbc',
    secondary: '#78828b',
    error: '#FF5252',
    warning: '#ff9800',
    info: '#03a9f4',
    success: '#4caf50',

    excel: '#1e7e34',
    pdf: '#dc3545'
  },
  options: {
    customProperties: true
  },
  iconfont: 'mdi',
  lang: {
    locales: { ro },
    current: 'ro'
  },
  directives: {
    Scroll
  }
})
